module.exports = __webpack_public_path__ + "static/turtle-creek-house10-b41423b052136ebd4ed7e349d58a132b.jpg";